export default "__VITE_ASSET__BFycUedJ__"